<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem [disabled]="isNotAllowsToEditUser"
      (click)="onEditUser()">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
    </button>
    <button ngbDropdownItem [disabled]="isNotAllowsToEditUser"
      (click)="onPasswordReset()">
      <span class="fa-solid fa-lock"></span>
      <span translate>Reset password</span>
    </button>
    <button ngbDropdownItem [disabled]="isNotAllowedToBanUser"
      (click)="onBanUser()">
      <span [ngClass]="banClass"></span>
      <span translate>Ban/Unban user</span>
    </button>
    <button
      #deleteButton
      ngbDropdownItem
      [disabled]="isNotAllowedToBanUser"
      [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
      (click)="onDeleteUser()">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span>
    </button>
  </div>
</div>
